import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Portal, Backdrop, IconButton, Typography } from '@mui/material';

import { useResponsive } from '../../../../services/hooks';
import Iconify from '../../../../components/Iconify';
import { FullScreenView } from './bonus-details/FullScreenView';
import { SimpleView } from './bonus-details/SimpleView';

const RootStyle = styled('div')(({ theme }) => ({
  right: 0,
  bottom: 0,
  zIndex: 1999,
  minHeight: 440,
  outline: 'none',
  display: 'flex',
  position: 'fixed',
  overflow: 'hidden',
  flexDirection: 'column',
  margin: theme.spacing(3),
  boxShadow: theme.customShadows.z20,
  borderRadius: Number(theme.shape.borderRadius) * 2,
  backgroundColor: theme.palette.background.paper
}));

export default function BonusDetails(
  { isOpenCompose, onCloseCompose, parentFullScreen, data, submitCallback, allSeasons, allResorts, allAgeRanges, allCamps }) {

  const [fullScreen, setFullScreen] = React.useState(false);

  const isDesktop = useResponsive('up', 'sm');

  React.useEffect(() => {
    setFullScreen(parentFullScreen);
  }, [parentFullScreen]);

  const handleExitFullScreen = () => {
    setFullScreen(false);
  };

  const handleEnterFullScreen = () => {
    setFullScreen(true);
  };

  const handleClose = () => {
    onCloseCompose();
    setFullScreen(false);
  };

  if (!isOpenCompose) {
    return null;
  }

  return (
    <Portal>
      <Backdrop open={fullScreen || !isDesktop} sx={{ zIndex: 1998 }} />
      <RootStyle
        sx={{
          ...(fullScreen && {
            top: 0,
            left: 0,
            zIndex: 1999,
            margin: 'auto',
            width: {
              xs: 'calc(100% - 24px)',
              md: 'calc(100% - 20px)'
            },
            height: {
              xs: 'calc(100% - 24px)',
              md: 'calc(100% - 10px)'
            }
          })
        }}
      >
        <Box
          sx={{
            pl: 3,
            pr: 1,
            height: 60,
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <Typography variant="h6">{data ? data.name : ''}</Typography>
          <Box sx={{ flexGrow: 1 }} />
          {data ? <IconButton onClick={fullScreen ? handleExitFullScreen : handleEnterFullScreen}>
            <Iconify icon={fullScreen ? 'eva:collapse-fill' : 'eva:expand-fill'} width={20} height={20} />
          </IconButton> : null}
          <IconButton onClick={handleClose}>
            <Iconify icon={'eva:close-fill'} width={20} height={20} />
          </IconButton>
        </Box>
        { fullScreen
          ? <FullScreenView
            data={data}
            submitCallback={submitCallback}
            handleClose={handleClose}/>
          : <SimpleView data={data} />
        }
      </RootStyle>
    </Portal>
  );
}
